import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-microphone-icon]',
  template: `
    <svg:path
      d="M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V5ZM12 3C10.8954 3 10 3.89543 10 5V12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12V5C14 3.89543 13.1046 3 12 3ZM5 9C5.55228 9 6 9.44772 6 10V12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V12C20 16.0796 16.9463 19.446 13 19.9381V21H16C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H8C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21H11V19.9381C7.05369 19.446 4 16.0796 4 12V10C4 9.44772 4.44772 9 5 9Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MicrophoneIcon {
  readonly viewBox = input<string>('0 0 24 24');
  readonly extraClass = input<string>('');
}
